import { render, staticRenderFns } from "./ExtraServiceContainer.vue?vue&type=template&id=6840cb3e"
import script from "@/scripts/extraService/extraServiceContainer.js?vue&type=script&lang=js&external"
export * from "@/scripts/extraService/extraServiceContainer.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports